export const LEVEL_TOLERANCES = {
    beginner: { centeredCents: 45, goodCents: 60 },
    intermediate: { centeredCents: 30, goodCents: 45 },
    advanced: { centeredCents: 18, goodCents: 32 },
};
export const DEFAULT_LEVEL = 'beginner';
//# sourceMappingURL=levels.js.map